module.exports = __webpack_public_path__ + "img/Feature.40997ce7.jpg";